import type { DefaultTheme } from 'styled-components';
import commonStyles from './common';

export const dark: DefaultTheme = {
	...commonStyles,
	colors: {
		main: '#FF9E45',
		red: '#FF6745',
		blue: '#459BFF',
		green: '#70BC78',
		background: '#010409',
		secondary: '#0D1117',
		primaryText: '#FFF',
		secondaryText: '#C58E2D',
		borderColor: '#606060',
		inputColor: '#060709',
		placeholderText: '#aaa',
		disabledColor: '#ddd',
		hoverColor: '#27272A'
	}
};
